import { useState, useEffect } from "react";
import { useHookForm } from "../../../../components/hooks";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../../../../redux/slice/system";
import { CommonAPI } from "../../../../axios/api";

import ModuleUploadFile from "../../../../components/uploadFile";
import { FormInputpassword } from "../../../../components/formElement";

import { classNames } from "primereact/utils";
import { Button } from "primereact/button";

export default function ModulePopPassword({ prePopOption, closePrePop }) {
  const dispatch = useDispatch();
  // 表單欄位預設值
  const defaultValues = {
    password: "",
    repassword: "",
  };
  const {
    handleSubmit,
    trigger,
    reset,
    watch,
    yup,
    setSchema,
    errors,
    setting,
  } = useHookForm({
    defaultValues,
  });
  // 監聽欄位
  const watchColumn = {
    password: watch("password"),
    repassword: watch("repassword"),
  };

  useEffect(() => {
    setSchema(
      yup
        .object({
          password: yup
            .string()
            .test(
              "isValidPass",
              "必填",
              (value, { from: [{ value: data }] }) => {
                return data.repassword
                  ? value && value === data.repassword
                  : true;
              }
            ),
          repassword: yup
            .string()
            .test(
              "isValidPass",
              "必填",
              (value, { from: [{ value: data }] }) => {
                return data.password ? value && value === data.password : true;
              }
            ),
        })
        .required()
    );
  }, []);

  // 動態判斷欄位
  useEffect(() => {
    if (setting.isSubmitted) trigger(["password", "repassword"]);
  }, [watchColumn.password, watchColumn.repassword]);

  // 表單驗證成功後，呼叫 API
  const onSubmit = (submitData) => {
    dispatch(setProgress(true));

    let jsonData = {
      id: prePopOption.data.id,
      new_password: submitData.password,
    };
    console.log(jsonData);

    CommonAPI.changePasswordByAdmin({
      data: jsonData,
    }).then((result) => {
      let { Response, message } = result;
      console.log(result);

      if (Response === 1) {
        dispatch(
          setToast({
            severity: "success",
            summary: `修改成功`,
            detail: "",
          })
        );

        closePrePop({ type: prePopOption.type });
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: `修改失敗`,
            detail: message ?? "",
          })
        );
      }
      dispatch(setProgress(false));
    });
  };

  return (
    <>
      <div className="px-4">
        <form onSubmit={handleSubmit(onSubmit)} className="formgrid grid">
          <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
            <label
              htmlFor="password"
              className={classNames(
                { "p-error": errors.password },
                "col-12 sm:col-3 text-left sm:text-right mb-1 sm:mb-0"
              )}
            >
              <span className="text-red-400 mr-1">*</span>
              新密碼
            </label>
            <div className="col-12 sm:col-9">
              <FormInputpassword
                setting={setting}
                data={{ name: "password" }}
              />
            </div>
          </div>

          <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
            <label
              htmlFor="repassword"
              className={classNames(
                { "p-error": errors.repassword },
                "col-12 sm:col-3 text-left sm:text-right mb-1 sm:mb-0"
              )}
            >
              <span className="text-red-400 mr-1">*</span>
              確認密碼
            </label>
            <div className="col-12 sm:col-9">
              <FormInputpassword
                setting={setting}
                data={{ name: "repassword" }}
              />
            </div>
          </div>

          <div className="col-12 text-right">
            <Button
              type="button"
              label="取消"
              className="p-button-secondary p-button-outlined ml-auto px-3"
              onClick={() => closePrePop({ type: prePopOption.type })}
            />
            <Button type="submit" label="儲存" className="ml-2 px-3" />
          </div>
        </form>
      </div>
    </>
  );
}
